import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Employee } from '../pages/';
import { Order } from '../pages/employee/Order';
import { Record } from '../pages/employee/Record';
import Settlement from '../pages/employee/Settlement';
import { FormListPanel } from '../components/form/FormListPanel';
import { FormSchemaUploadPanel } from '../components/form/FormSchemaUploadPanel';
import Notification from '../pages/employee/Notification';
import AgreementsTemplates from '../pages/employee/AgreementsTemplates';
import Surveys from '../pages/employee/Surveys';
import SurveyDetails from '../pages/employee/SurveyDetails';
import { Statistics } from '../pages/employee/Statistics';
import { Alert } from '../pages/employee/Alert';
import { Applications } from '../pages/employee/Applications';
import { Employees } from '../pages/employee/Employees';
import RecruitmentFormsListPage from '../pages/employee/RecruitmentFormsListPage';
import Form from '../components/json-forms/Form';
import AccomodationDiagram from '../pages/employee/AccomodationDiagram';
import WorkStandard from '../pages/employee/WorkStandard';
import { AppProvider } from '../AppContext';
import EssentialDocument from '../pages/employee/EssentialDocument';
import EmployeesAccounts from '../pages/employee/EmployeesAccounts';
import PersonalDataProtectionDocument from '../pages/employee/PersonalDataProtectionDocument';
import OrganizingCampsInstructionDocument from '../pages/employee/OrganizingCampsInstructionDocument';
import OrganizationalDocumentSections from '../sections/manager/OrganizationalDocumentSections';
import TemplateDocument from '../pages/employee/TemplateDocument';
import { LoginPage } from '../components/authorization/LoginPage';
import SaleCalendar from '../pages/employee/SaleCalendar';
import { Tfg } from '../pages/employee/Tfg';

export default () => {
  const { employeePermissions } = useSelector(state => state.app);

  return (
    <AppProvider>
      <Routes>
        <Route path="*" element={<Navigate to="/employee" />} />

        <Route path="/employee" element={<Employee />}>
          <Route path="orders" element={<Order />} />
          <Route
            path="upload-form-schema"
            element={<FormSchemaUploadPanel />}
          />
          <Route path="form-list" element={<FormListPanel />} />
          <Route path="r-form-list" element={<RecruitmentFormsListPage />} />
          {employeePermissions.includes('view_settlements') ? (
            <Route path="settlements" element={<Settlement />} />
          ) : (
            <Route path="*" element={<Navigate to="/employee" />} />
          )}
          <Route path="records" element={<Record />} />
          <Route path="notifications" element={<Notification />} />
          <Route path="templates" element={<AgreementsTemplates />} />
          <Route path="work-standards" element={<WorkStandard />} />
          <Route
            path="personal-data-protection-documents"
            element={<PersonalDataProtectionDocument />}
          />
          <Route
            path="organizing-camps-instruction-documents"
            element={<OrganizingCampsInstructionDocument />}
          />
          <Route path="essential-documents" element={<EssentialDocument />} />
          <Route path="template-documents" element={<TemplateDocument />} />
          <Route path="survey" element={<Surveys />} />
          <Route path="survey/:id" element={<SurveyDetails />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="alert" element={<Alert />} />
          <Route
            path="rekrutacja/formularz"
            element={<Form identifier="rekrutacja" admin={true} />}
          />
          <Route
            path="kwestionariusz/formularz"
            element={<Form identifier="kwestionariusz" />}
          />
          <Route path="applications" element={<Applications />} />
          <Route path="employees" element={<Employees />} />
          <Route path="accommodation" element={<AccomodationDiagram />} />
          <Route
            path="accommodation/:resort/:camp"
            element={<AccomodationDiagram />}
          />
          <Route path="accounts-management" element={<EmployeesAccounts />} />
          <Route
            path="organizational-documents"
            element={<OrganizationalDocumentSections officeView={true} />}
          />
          <Route
            path="login-5475968434606-admin-qqqq"
            element={<LoginPage admin={true} />}
          />
          <Route path="sale-calendar" element={<SaleCalendar />} />
          <Route path="tfg" element={<Tfg />} />
        </Route>
      </Routes>
    </AppProvider>
  );
};
